import React from 'react';

export const CheckIcon = () => (
    <svg data-name="Component 171-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
            id="Path_5699"
            data-name="Path 5699"
            d="M17.21,7.2a10,10,0,1,1-10,10,10,10,0,0,1,10-10ZM12.26,17.33a1,1,0,1,1,1.477-1.337l2.491,2.752,5.383-5.56a1,1,0,0,1,1.43,1.392L16.92,20.9h0c-.014.015-.03.03-.046.044a1,1,0,0,1-1.407-.07L12.259,17.33Z"
            transform="translate(-7.21 -7.2)"
            fill="#1faa2d"
            fill-rule="evenodd"
        />
    </svg>
);
